var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g({staticClass:"zoox-component zoox-status",attrs:{"dark":"","tabindex":"0","color":_vm.color}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }